/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import { cloneDeep, sumBy } from 'lodash';
import moment from 'moment';

import { isBetweenFromAndToDates } from 'services/Dates';

import {
  RECEIVED_MESSAGES,
  RECEIVED_MMR_MESSAGES
} from 'state/notification/NotificationActions';

export const notificationReducer = (state = {}, action) => {
  if (action.type !== RECEIVED_MESSAGES) {
    return state;
  }

  const notification = cloneDeep(state);
  notification.messages = action.messages || [];
  notification.unreadMessageCount = sumBy(action.messages, (message) =>
    message.viewed ? 0 : 1
  );
  return notification;
};

export const mmrMessagesReducer = (state = {}, action) => {
  if (action.type === RECEIVED_MMR_MESSAGES) {
    const mmr = action.mmrMessages || {};
    const { globalMessage, hasMmrEvent, messages } = mmr;
    const accountMessageMap = new Map();
    if (messages) {
      const now = moment.utc();
      messages.forEach((msg) => {
        const { ticker, message, beginDate, endDate } = msg;
        if (isBetweenFromAndToDates(now, beginDate, endDate)) {
          accountMessageMap.set(ticker, message);
        }
      });
    }
    return {
      globalMessage,
      hasMmrEvent,
      messages: accountMessageMap
    };
  }
  return state;
};

mmrMessagesReducer.priority = 18;
